import { render, staticRenderFns } from "./RouteInfoRootPage.vue?vue&type=template&id=61709f9f&"
import script from "./RouteInfoRootPage.vue?vue&type=script&lang=js&"
export * from "./RouteInfoRootPage.vue?vue&type=script&lang=js&"
import style0 from "./RouteInfoRootPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports